var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-message"},[_c('div',{staticClass:"chat-item-image"},[_c('img',{attrs:{"src":_vm.data.originalContentUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }